import { render, staticRenderFns } from "./SalesListItemMobile.vue?vue&type=template&id=62824f97&scoped=true&"
import script from "./SalesListItemMobile.vue?vue&type=script&lang=js&"
export * from "./SalesListItemMobile.vue?vue&type=script&lang=js&"
import style0 from "./SalesListItemMobile.vue?vue&type=style&index=0&id=62824f97&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62824f97",
  null
  
)

component.options.__file = "SalesListItemMobile.vue"
export default component.exports